import {ApplicationState, connect} from '@modifi/redux'
import {aPush, selectPathname, selectSearch} from '@modifi/router'

import RegionAndLocaleDropdown, {RegionAndLocaleDropdownProps} from './RegionAndLocaleDropdown'
import {selectRegionsAndLocales} from '../../../../../data/navigation'

const mapStateToProps = (
  state: ApplicationState
): Pick<RegionAndLocaleDropdownProps, 'regionAndLocaleMap' | 'queryParams' | 'routePathName'> => ({
  regionAndLocaleMap: selectRegionsAndLocales(state),
  queryParams: selectSearch(state),
  routePathName: selectPathname(state),
})

const mapDispatchToProps = {
  redirect: aPush,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegionAndLocaleDropdown)
